module.exports = __webpack_public_path__ + "static/media/dice-2.d829e3a7.png";